var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20156 22.5H1.84688V8.47969H6.20156V22.5ZM4.02187 6.56719C2.62969 6.56719 1.5 5.41406 1.5 4.02187C1.5 3.35303 1.7657 2.71158 2.23864 2.23864C2.71158 1.7657 3.35303 1.5 4.02187 1.5C4.69072 1.5 5.33217 1.7657 5.80511 2.23864C6.27805 2.71158 6.54375 3.35303 6.54375 4.02187C6.54375 5.41406 5.41406 6.56719 4.02187 6.56719ZM22.4953 22.5H18.15V15.675C18.15 14.0484 18.1172 11.9625 15.8859 11.9625C13.6219 11.9625 13.275 13.7297 13.275 15.5578V22.5H8.925V8.47969H13.1016V10.3922H13.1625C13.7438 9.29062 15.1641 8.12812 17.2828 8.12812C21.6891 8.12812 22.5 11.0297 22.5 14.7984V22.5H22.4953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/linked-in-logo.fa0098951e110cec52af0dfebfb1d4b0.svg";
export { ForwardRef as ReactComponent };